export class MenuDto {
  constructor(
    public name: string,
    public message: string,
    public status: number
  ) {}
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dto/menu.dto.ts